import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";

const DefaultActionMenuIcon = () => <FontAwesomeIcon icon={["fas", "clone"]}/>

export default DefaultActionMenuIcon;